import { Component, Inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogTitle,
} from '@angular/material/dialog';
import { FormioForm } from '@formio/angular';
import { ScwFormioComponent } from 'scw-digital-boards-widgets';

export interface IFormioDialogData {
  title: string;
  form: FormioForm;
  submission?: object;
}

@Component({
  imports: [MatDialogClose, MatDialogContent, MatDialogActions, MatButton, ScwFormioComponent, MatDialogTitle],
  selector: 'app-formio-dialog',
  template: `
    <h1 mat-dialog-title>{{ data.title }}</h1>
    <div mat-dialog-content>
      <app-scw-formio class="pointer-events-none" [form]="data.form" [submission]="data.submission"></app-scw-formio>
    </div>
    <div mat-dialog-actions align="end">
      <button matButton="tonal" mat-dialog-close>Close</button>
    </div>
  `,
})
export class FormioDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: IFormioDialogData) {}
}
